import routes from './routes';
import { SetRoutes } from 'components';

const VacancyApplicationsPages = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default VacancyApplicationsPages;
